import { defineStore } from 'pinia';
import { setCssVar } from 'quasar';
import dayjs from 'dayjs';
import { computed, ref, watch } from 'vue';

import { useUserStore } from './useUserStore';
export const useAppSettingsStore = defineStore(
  'AppSettings',
  () => {
    //Store state variables
    const theme = ref(null);
    const debugMode = ref(false);
    const forceMobileMenu = ref(false);
    const showTooltips = ref(true);
    const darkMode = ref(false);
    const secondaryColor = ref(null);
    const darkColor = ref(null);
    const displayMenuLabel = ref(true);
    const displayRightDrawer = ref(false);
    const employeMode = ref({ active: false, orig_id: null, employe: null });
    const lateBannerDismissedAt = ref<string | null>(null);

    const dateFormat = ref({
      label: 'AAAA-MM-JJ',
      value: 'YYYY-MM-DD'
    });

    const UserStore = useUserStore();
    // Methods
    const setTheme = () => {
      if (theme.value) for (const [key, value] of Object.entries(theme.value?.colors || {})) setCssVar(key, value as string);
    };

    const switchUser = () => {
      // @ts-ignore - Bypass TypeScript check for regenUserData
      if (typeof UserStore.regenUserData === 'function') {
        // @ts-ignore
        UserStore.regenUserData(true);
      }
    };

    const employeModeId = computed(() => (employeMode.value.active && employeMode.value.employe ? employeMode.value.employe.id : false));

    const dismissLateBanner = () => {
      lateBannerDismissedAt.value = new Date().toISOString();
    };

    const isLateBannerDismissed = computed(() => {
      if (!lateBannerDismissedAt.value) return false;
      const dismissedTime = dayjs(lateBannerDismissedAt.value);
      const currentTime = dayjs();
      return currentTime.diff(dismissedTime, 'hour') < 24;
    });

    watch(theme, () => {
      if (theme.value) setTheme();
    });

    const formattedDate = computed(() => (e: any = null) => dayjs(e).format(dateFormat.value.value));
    const formattedDateTime = computed(() => (e: any = null) => dayjs(e).format(dateFormat.value.value + ' H:m:s'));
    return {
      formattedDate,
      formattedDateTime,
      dateFormat,
      setTheme,
      switchUser,
      employeModeId,
      debugMode,
      employeMode,
      forceMobileMenu,
      showTooltips,
      darkMode,
      secondaryColor,
      darkColor,
      displayMenuLabel,
      displayRightDrawer,
      theme,
      lateBannerDismissedAt,
      dismissLateBanner,
      isLateBannerDismissed
    };
  },
  { persist: true }
);
